import * as React from 'react';
import {
    ContextualMenu,
    DirectionalHint,
    IContextualMenuItem,
} from 'office-ui-fabric-react/lib/components/ContextualMenu';
import { FONT_NAME_LIST, FontName, getLocalizedFontName } from 'owa-format-options';

let styles = require('./Ribbon.scss');
let classNames = require('classnames');

// Used as a key for divider, because IContextualMenuItem requires each element to have a different key
let dividerKey = 0;

export interface FontNamePickerProps {
    menuTargetElement: HTMLElement;
    onDismissMenu: () => void;
    onSelectName: (value: FontName) => void;
    selectedName?: string;
    shouldFocusOnMount?: boolean;
}

export default class FontNamePicker extends React.Component<FontNamePickerProps, {}> {
    private createMenuItems(): IContextualMenuItem[] {
        let menuItems: IContextualMenuItem[] = [];
        let checkComplete: boolean = this.props.selectedName ? false : true;
        FONT_NAME_LIST.forEach((item: FontName) => {
            let isChecked: boolean = checkComplete
                ? false
                : this.props.selectedName.toLowerCase() == item.name.toLowerCase();
            if (isChecked) {
                checkComplete = true;
            }

            if (item.name == '-') {
                //divider items
                menuItems.push({
                    key: 'divider_' + (dividerKey++).toString(),
                    name: '-',
                });
            } else {
                menuItems.push({
                    key: item.name,
                    name: getLocalizedFontName(item),
                    canCheck: true,
                    checked: isChecked,
                    style: { fontFamily: item.family },
                    onClick: () => this.onSelectName(item),
                });
            }
        });

        return menuItems;
    }

    private onSelectName(fontName: FontName) {
        this.props.onDismissMenu();
        this.props.onSelectName(fontName);
    }

    render() {
        let { onDismissMenu, menuTargetElement, shouldFocusOnMount } = this.props;
        let items: IContextualMenuItem[] = this.createMenuItems();
        let pickerStyle = classNames(styles.fontPickerContainer, 'customScrollBar');
        return (
            <ContextualMenu
                className={pickerStyle}
                shouldFocusOnMount={shouldFocusOnMount}
                target={menuTargetElement}
                directionalHint={DirectionalHint.bottomLeftEdge}
                onDismiss={onDismissMenu}
                items={items}
            />
        );
    }
}
